<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      <v-col cols="11" class="mx-auto">
        <p
          :class="
            mobile()
              ? 'text-h5 font-weight-bold ml-16 mr-16'
              : 'text-h5 font-weight-bold'
          "
          :align="mobile() ? 'center' : 'left'"
        >
          {{ $t("spaceSettingsTitle") }}
        </p>
        <p class="text-body-1 greytext--text d-none d-sm-block">
          {{ $t("spaceSettingsText") }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="11" class="mx-auto">
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  data-testid="space-name-card"
                  rounded="xxl"
                  max-width="400"
                  class="mx-auto mx-md-0 pa-4 pb-8"
                  :elevation="hover ? 8 : 5"
                >
                  <EditSpaceName
                    :space-name="name"
                    @proceedSubmit="updateSpaceName"
                  />
                  <v-card-title class="font-weight-bold no-break">
                    {{ $t("editSpaceNameCardTitle") }}
                  </v-card-title>
                  <v-card-text class="text-body-1">
                    {{ name }}
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  data-testid="space-logo-card"
                  rounded="xxl"
                  max-width="400"
                  class="mx-auto mx-md-0 pa-4"
                  :elevation="hover ? 8 : 5"
                >
                  <v-card-title class="font-weight-bold no-break" :class="{'disabled--text': productPlan.attributes && productPlan.attributes.name == 'Free'}">
                    {{ $t("createSpaceCardLogoTitle") }}
                  </v-card-title>
                  <v-card-actions class="pt-0 d-block d-sm-flex">
                    <v-img
                      v-if="loadingData"
                      data-testid="logo-image"
                      height="40"
                      max-width="150"
                      contain
                      position="left"
                      src=""
                      :class="logoURL != null ? '' : 'default'"
                    />
                    <v-img
                      v-else
                      data-testid="logo-image"
                      height="40"
                      max-width="150"
                      contain
                      position="left"
                      :src="
                        logoURL != null
                          ? logoURL
                          : require('../../assets/rtplogo.svg')
                      "
                      :class="logoURL != null ? '' : 'default'"
                    />
                    <v-spacer />
                    <v-file-input
                      ref="file_input_logo"
                      v-model="logoData"
                      accept="image/png, image/jpeg, image/svg+xml"
                      data-testid="logo-file-input"
                      class="d-none"
                      @change="uploadSpaceLogo"
                    />
                                                                      

                    <v-menu offset-y flat bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :loading="loadingLogo"
                          data-testid="upload-logo-button"
                          icon
                          absolute
                          right
                          top
                          class="mt-n2 mr-n2"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="productPlan.attributes && productPlan.attributes.name == 'Free'"
                          :class="{'disabled-button-free': productPlan.attributes && productPlan.attributes.name == 'Free'}"
                        >
                          <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="rounded-lg mr-2 px-2" x-small color="accent" text-color="white">PRO</v-chip>
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <v-list data-testid="menu-list">
                        <v-list-item
                          data-testid="show-uploader-item"
                          router
                          @click="showUploadLogo"
                        >
                          <v-list-item-title>{{
                            $t("uploadNew")
                          }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="logoURL != null"
                          data-testid="remove-logo-item"
                          router
                          @click.stop="
                            (dialogVisibleDeleteLogo = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteLogo'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteLogo'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                          "
                        >
                          <v-list-item-title>{{
                            $t("delete")
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                </v-card>
              </template>
            </v-hover>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  data-testid="space-icon-card"
                  rounded="xxl"
                  max-width="400"
                  class="mx-auto mx-md-0 pa-4"
                  :elevation="hover ? 8 : 5"
                >
                  <v-card-title class="font-weight-bold no-break" :class="{'disabled--text': productPlan.attributes && productPlan.attributes.name == 'Free'}">
                    {{ $t("createSpaceCardIconTitle") }}
                  </v-card-title>
                  <v-card-actions class="pt-0 d-block d-sm-flex">
                    <v-img
                      v-if="loadingData"
                      data-testid="icon-image"
                      class="mx-4"
                      max-width="40"
                      width="40"
                      height="40"
                      src=""
                      :class="iconURL != null ? '' : 'default'"
                    />
                    <v-img
                      v-else
                      data-testid="icon-image"
                      class="mx-4"
                      max-width="40"
                      width="40"
                      height="40"
                      :src="
                        iconURL != null
                          ? iconURL
                          : require('../../assets/rtpicon.png')
                      "
                      :class="iconURL != null ? '' : 'default'"
                    />
                    <v-spacer />
                    <v-file-input
                      ref="file_input_icon"
                      v-model="iconData"
                      accept="image/png, image/jpeg, image/svg+xml, image/ico, image/x-icon"
                      data-testid="icon-file-input"
                      class="d-none"
                      @change="uploadSpaceIcon"
                    />
                    <v-menu offset-y flat bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :loading="loadingIcon"
                          data-testid="upload-icon-button"
                          icon
                          absolute
                          right
                          top
                          class="mt-n2 mr-n2"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="productPlan.attributes && productPlan.attributes.name == 'Free'"
                          :class="{'disabled-button-free': productPlan.attributes && productPlan.attributes.name == 'Free'}"
                        >
                          <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="rounded-lg mr-2 px-2" x-small  color="accent" text-color="white">PRO</v-chip>
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <v-list data-testid="menu-list">
                        <v-list-item
                          data-testid="show-uploader-item"
                          router
                          @click="showUploadIcon"
                        >
                          <v-list-item-title>{{
                            $t("uploadNew")
                          }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="iconURL != null"
                          data-testid="remove-icon-item"
                          router
                          @click.stop="
                            (dialogVisibleDeleteIcon = true),
                              (confirmationDialogTitle = $t(
                                'confirmationDialogTitleDeleteIcon'
                              )),
                              (confirmationDialogText = $t(
                                'confirmationDialogTextDeleteIcon'
                              )),
                              (confirmationDialogSubmitBtn = $t('delete'));
                            confirmationDialogCancelBtn = $t('no');
                          "
                        >
                          <v-list-item-title>{{
                            $t("delete")
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                </v-card>
              </template>
            </v-hover>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  data-testid="space-url-card"
                  rounded="xxl"
                  max-width="400"
                  class="mx-auto mx-md-0 pa-4 pb-8"
                  :elevation="hover ? 8 : 5"
                >
                  <v-card-title class="font-weight-bold no-break">
                    {{ $t("editSpaceURLCardTitle") }}
                  </v-card-title>
                  <v-card-text class="text-body-1">
                    {{ url }}.{{ domain }}
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>
          <v-col cols="12" md="6" lg="4" v-if="productPlan.attributes && (productPlan.attributes.name != 'Free' && productPlan.attributes.name != 'Pro Trial')">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  data-testid="delete-space-card"
                  rounded="xxl"
                  max-width="400"
                  class="mx-auto mx-md-0 pa-4 pb-8"
                  :elevation="hover ? 8 : 5"
                >
                  <v-btn
                    data-testid="submit-button"
                    color="error"
                    icon
                    absolute
                    right
                    top
                    class="mt-n2 mr-n2"
                    @click="confirmDeleteSpace"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-card-title class="font-weight-bold no-break">
                    {{ $t("deleteSpace") }}
                  </v-card-title>
                  <v-card-text class="text-body-1">
                    {{ $t("deleteSpaceTextCard") }}
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  data-testid="space-name-card"
                  rounded="xxl"
                  max-width="400"
                  class="mx-auto mx-md-0 pa-4 pb-8"
                  :elevation="hover ? 8 : 5"
                >
                  <EditSpaceOwner
                    :selected-owner="spaceOwner"
                    @proceedSubmit="updateSpaceOwner"
                  /> 
                  <v-card-title class="font-weight-bold no-break">
                    {{ $t("editSpaceOwner") }}
                  </v-card-title>
                  <v-card-text class="text-body-1">
                    {{ spaceOwner }}
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  data-testid="show-google-card"
                  rounded="xxl"
                  max-width="400"
                  class="mx-auto mx-md-0 pa-4 pb-8 checkbox-align-start"
                  :elevation="hover ? 8 : 5"
                >
                  <v-card-title class="font-weight-bold no-break">
                    {{ $t("spaceSettingsGoogleCardTitle") }}
                  </v-card-title>
                  <v-card-text class="text-body-1">
                    <v-checkbox
                      v-model="showGoogleLogin"
                      color="accent"
                      class="black--text rounded-xxl mt-0 pt-0 mb-0 show-google"
                      :class="{ 'selected' : showGoogleLogin}"
                      data-testid="show-google-login"
                      hide-details
                      @change="showHideGoogleLogin"
                    >
                      <template v-slot:label>
                        <div>
                          <span class="text-body-1 greytext--text font-weight-regular">{{ $t('spaceSettingsGoogleCardText') }}</span> 
                        </div>
                      </template>
                    </v-checkbox>
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>
          <v-col cols="12" md="6" lg="4" v-if="isOwner">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  data-testid="show-email-templates-card"
                  rounded="xxl"
                  max-width="400"
                  class="mx-auto mx-md-0 pa-4 pb-8"
                  :elevation="hover ? 8 : 5"
                  @click="showEmailTemplates"
                >
                  <v-card-title class="font-weight-bold no-break">
                    {{ $t("spaceSettingsEmailTemplatesCardTitle") }}
                  </v-card-title>
                  <v-card-text class="text-body-1">
                    {{ $t("spaceSettingsEmailTemplatesCardText") }}
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  data-testid="space-default-language-card"
                  rounded="xxl"
                  max-width="400"
                  class="mx-auto mx-md-0 pa-4 pb-8"
                  :elevation="hover ? 8 : 5"
                >
                  <EditSpaceDefaultLanguage
                    @proceedSubmit="updateDefaultLanguage"
                  />
                  <v-card-title class="font-weight-bold no-break">
                    {{ $t("editDefaultLanguageCardTitle") }}
                  </v-card-title>
                  <v-card-text class="text-body-1">
                     {{languageReadable}}
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  data-testid="space-dashboard-card"
                  rounded="xxl"
                  max-width="400"
                  class="mx-auto mx-md-0 pa-4 pb-8"
                  :elevation="hover ? 8 : 5"
                >
                  <EditSpaceDashboard
                  :space-dashboard-title="title"
                  :space-dashboard-description="description"
                    @proceedSubmit="updateSpaceDashboard"
                  />
                  <v-card-title class="font-weight-bold no-break">
                    {{ $t("editDashboard") }}
                  </v-card-title>
                  <v-card-text class="text-body-1">
                    {{ $t("editDashboardText") }}
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ConfirmationDialog
      v-if="dialogVisibleDeleteLogo"
      ref="confirmationDialogDeleteLogo"
      :visible="dialogVisibleDeleteLogo"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-delete-logo"
      @close="dialogVisibleDeleteLogo = false"
      @proceedSubmit="removeLogoImage"
    />
    <ConfirmationDialog
      v-if="dialogVisibleDeleteIcon"
      ref="confirmationDialogDeleteIcon"
      :visible="dialogVisibleDeleteIcon"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-delete-icon"
      @close="dialogVisibleDeleteIcon = false"
      @proceedSubmit="removeIconImage"
    />
  </nav>
</template>
<script>
import i18n from "../../plugins/i18n";
import EditSpaceName from "./EditSpaceName";
import EditSpaceOwner from "./EditSpaceOwner";
import EditSpaceDefaultLanguage from "./EditSpaceDefaultLanguage";
import EditSpaceDashboard from "./EditSpaceDashboard";
import { getSpace, updateSpace, uploadSpaceImage } from "../../api/spaceApi";
import { eventBus } from "../../eventbus";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import AlertMessages from "../../components/AlertMessages";
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";

export default {
  components: {
    EditSpaceName,
    EditSpaceOwner,
    EditSpaceDefaultLanguage,
    EditSpaceDashboard,
    ConfirmationDialog,
    AlertMessages,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      valid: true,
      name: "",
      url: "",
      defaultLanguage: localStorage.space ? JSON.parse(localStorage.space).language : 'en',
      languageReadable: 'english',
      alertType: "",
      alertMsg: "",
      alertValue: false,
      buttonDisabled: false,
      logoData: null,
      iconData: null,
      logoURL: null,
      iconURL: null,
      loadingLogo: false,
      loadingIcon: false,
      loadingData: false,
      spaceId: window.$cookies.get("space_id"),
      dialogVisibleDeleteLogo: false,
      dialogVisibleDeleteIcon: false,
      confirmationDialogTitle: "",
      confirmationDialogText: "",
      confirmationDialogCancelBtn: "",
      confirmationDialogSubmitBtn: "",
      domain: process.env.VUE_APP_DOMAIN,
      spaceOwner:"",
      showGoogleLogin: false,
      isOwner: localStorage.space ? JSON.parse(localStorage.space).is_owner : false,
      title:'',
      description:'',
    };
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  async created() {
    try {
      this.loadingData = true;
      const response = await getSpace(this.spaceId);
      if (response.status == 200) {
        this.name = response.data.data.attributes.name;
        this.url = response.data.data.attributes.subdomain;
        this.logoURL = response.data.data.attributes.logo
          ? response.data.data.attributes.logo
          : null;
        this.iconURL = response.data.data.attributes.icon
          ? response.data.data.attributes.icon
          : null;
        this.spaceOwner = response.data.data.attributes.owner_email
        this.showGoogleLogin = response.data.data.attributes.show_google_login
        this.loadingData = false;
      }
    } catch (e) {
      if (e.response) {
        this.alertType = "error";
        this.alertMsg = i18n.t("serverError");
        this.alertValue = true;
        this.loadingData = false;
      }
    }
     switch(this.defaultLanguage) {
            case 'en':
                this.languageReadable = i18n.t('english')
                break;
            case 'sv':
                this.languageReadable = i18n.t('swedish')
                break;
            case 'mk':
                this.languageReadable = i18n.t('macedonian')
                break;
            default:
                this.languageReadable = i18n.t('english')
        }
  },
  methods: {
    confirmDeleteSpace() {
     this.$router.push({ path: "/space/delete" });
    },
    async updateSpace(type) {
      if (type == "logo") {
        let data = {
          data: {
            type: "spaces",
            id: this.spaceId,
            attributes: {
              logo: this.logoPath,
            },
          },
        };
        try {
          const response = await updateSpace(this.spaceId, data);
          if (response.status == 200) {
            this.alertMsg = "";
            this.loadingLogo = false;
            this.logoURL = response.data.data.attributes.logo;
            localStorage.space = JSON.stringify(response.data.data.attributes);
            eventBus.$emit("changeLogo", "updateSpace");
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      } else {
        let data = {
          data: {
            type: "spaces",
            id: this.spaceId,
            attributes: {
              icon: this.iconPath,
            },
          },
        };
        try {
          const response = await updateSpace(this.spaceId, data);
          if (response.status == 200) {
            this.loadingIcon = false;
            this.iconURL = response.data.data.attributes.icon;
            localStorage.space = JSON.stringify(response.data.data.attributes);
          }
        } catch (e) {
          if (e.response) {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
            this.alertValue = true;
          }
        }
      }
    },

    async uploadSpaceLogo() {
      if (this.logoData.size > 3145728) {
        this.alertType = "error";
        this.alertMsg = i18n.t("createSpaceErrorLogo");
        this.alertValue = true;
      } else {
        this.loadingLogo = true;
        try {
          let data = new FormData();
          data.append("file", this.logoData);
          data.append("type", "logo");

          const response = await uploadSpaceImage(data);
          if (response.status == 200) {
            this.logoPath = response.data.meta.detail;
            this.updateSpace("logo");
          }
        } catch (e) {
          this.alertValue = true;
          if (e.response) {
            if (e.response.status == 422) {
              this.alertType = "error";
              this.alertMsg = i18n.t("createSpaceErrorLogo");
            }else if (e.response.status == 403){
              for(let i = 0; i < e.response.data.errors.length; i++){
                if(e.response.data.errors[i].detail == 'Storage is full'){
                  this.alertType = "error";
                  this.alertMsg =  i18n.t('storageFullError')
                }
                else {
                  this.$router.push({name: 'PageAccessDenied'})
                }
              }
            } else {
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
            }
          }
          this.loadingLogo = false;
        }
      }
    },
    async uploadSpaceIcon() {
      if (this.iconData.size > 1048576) {
        this.alertType = "error";
        this.alertMsg = i18n.t("createSpaceErrorIcon");
        this.alertValue = true;
      } else {
        this.loadingIcon = true;
        try {
          let data = new FormData();
          data.append("file", this.iconData);
          data.append("type", "icon");

          const response = await uploadSpaceImage(data);
          if (response.status == 200) {
            this.iconPath = response.data.meta.detail;
            this.updateSpace("icon");
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true;
            this.alertType = "error";
            if (e.response.status == 422) {
              this.alertMsg = i18n.t("createSpaceErrorIcon");
            }else if (e.response.status == 403){
              for(let i = 0; i < e.response.data.errors.length; i++){
                if(e.response.data.errors[i].detail == 'Storage is full'){
                  this.alertMsg =  i18n.t('storageFullError')
                }
                else {
                  this.$router.push({name: 'PageAccessDenied'})
                }
              }
            } else {
              this.alertMsg = i18n.t("serverError");
            }
          }
          this.loadingIcon = false;
        }
      }
    },
    showUploadLogo() {
      this.$refs.file_input_logo.$refs.input.click();
    },
    showUploadIcon() {
      this.$refs.file_input_icon.$refs.input.click();
    },
    updateDefaultLanguage(msg, type) {
      if (msg) {
        this.alertType = type;
        this.alertMsg = msg;
        this.alertValue = true;
      }
      this.defaultLanguage = JSON.parse(localStorage.space).language;
      this.languageReadable = this.defaultLanguage == 'en' ? i18n.t('english') : this.defaultLanguage == 'sv' ? i18n.t('swedish') : this.defaultLanguage == 'mk' ? i18n.t('macedonian') : i18n.t('english')
    },
    updateSpaceName(msg, type) {
      if (msg) {
        this.alertType = type;
        this.alertMsg = msg;
        this.alertValue = true;
      }
      this.name = JSON.parse(localStorage.space).name;
    },
    updateSpaceDashboard(msg, type) {
      if (msg) {
        this.alertType = type;
        this.alertMsg = msg;
        this.alertValue = true;
      }
      this.title = JSON.parse(localStorage.space).dashboard_title;
      this.description = JSON.parse(localStorage.space).dashboard_text;
    },
    updateSpaceOwner(msg, type) {
      if (msg) {
        this.alertType = type;
        this.alertMsg = msg;
        this.alertValue = true;
      }
      this.spaceOwner = JSON.parse(localStorage.space).owner_email;
    },
    
    async removeLogoImage() {
      this.dialogVisibleDeleteLogo = false;
      this.loadingLogo = true;

      this.logoPath = null;
      try {
        await this.updateSpace("logo");
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }

      this.loadingLogo = false;
    },
    async removeIconImage() {
      this.dialogVisibleDeleteIcon = false;
      this.loadingIcon = true;

      this.iconPath = null;

      try {
        await this.updateSpace("icon");
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }

      this.loadingIcon = false;
    },
    async showHideGoogleLogin(value){
      let data = {
          data: {
            type: "spaces",
            id: this.spaceId,
            attributes: {
              show_google_login: value
            },
          },
        };
      try {
          const response = await updateSpace(this.spaceId, data);
          if (response.status == 200) {
            this.loadingIcon = false;
            this.iconURL = response.data.data.attributes.icon;
            localStorage.space = JSON.stringify(response.data.data.attributes);
          }
        } catch (e) {
          if (e.response) {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
            this.alertValue = true;
          }
        }
    },
    showEmailTemplates(){
      this.$router.push({name: 'EmailTemplates'})
    }
  },
};
</script>